module.exports = __webpack_public_path__ + "static/img/a04.ba538f85.jpg";